import React, { Component, useState } from 'react'
import * as _ from 'lodash'
import PropTypes from 'prop-types'

import { Form } from 'react-bootstrap';
import NumberFormat, { NumberFormatProps } from 'react-number-format';

const myProps = ["length", "customValidate", 'showError']

const isNumeric = (value): boolean => {
    return /^-?\d+$/.test(value);
}
const omitProps = [
    "length",
    "customValidate",
    "showError",
    'editable',
    'validated',
    'onlyNumeric',
    'showFeedback',

    // Event listeners
    'onValueChange',
    'onChange',
    "onBlur",
];
const propNotPass = {
    length: "",
    showError: true,
}

export interface INumberFormatValidateProps extends NumberFormatProps {
    max?: number
    min?: number
    length?: number
    customValidate?(value: number): boolean
    validated?: boolean
    onlyNumeric?: boolean, // use for show warning 
    showFeedback?: boolean,
    customInput?:any
}

const NumberFormatValidate: React.FC<INumberFormatValidateProps> = (props): JSX.Element => {

    const { max, min, length, customValidate } = props
    const [isValid, setIsValid] = useState(false)
    const [validated, setValidated] = useState(false)
    const [showWarning, setShowWarning] = useState(false);
    let inputElem = React.useRef(null);
    const otherProps = {};

    React.useEffect(() => {
        setValidated(props.validated)
    }, [props.validated]);

    const setCustomValidity = (isValid) => {

        if (props.required && inputElem && inputElem.current) {
            if (!isValid) {
                // console.log("setCustomValidity", false)
                inputElem.current.setCustomValidity("Invalid field.")
            } else {
                // console.log("setCustomValidity", true)
                inputElem.current.setCustomValidity("")
            }
        }
    }

    const validateInput = (value) => {
        let isValid = true;
        if (max != null && value > max) {
            isValid = false
        }
        if (min != null && value < min) {
            isValid = false
        }

        if (length != null && (value == undefined || value.toString().length != length)) {
            if (value != undefined) {

            }

            isValid = false
        }
        setCustomValidity(isValid)
        return isValid;
    }

    // console.log("NumberFormatValidate",props)
    return (
        <>
            <NumberFormat
                {..._.omit(props, omitProps)}
                onValueChange={(values, sourceInfo) => {
                    const { formattedValue, value, floatValue } = values;
                    let valid = false;
                    if (customValidate) {
                        valid = customValidate(floatValue)
                        setCustomValidity(valid)
                    } else {
                        valid = validateInput(floatValue)
                    }

                    if (props.required) {
                        setCustomValidity(valid)
                    }
                    setIsValid(valid)
                    // setValidated(true)
                    if (props.onValueChange) {
                        props.onValueChange(values, sourceInfo)
                    }
                    // setIsValid(event.target.validity.valid || validateInput(event.target.value))

                }}
                onChange={(event) => {
                    let value = event.target.value
                    // console.log("value", value)
                    if (props.onlyNumeric) {
                        if (!isNumeric(value)) {
                            setShowWarning(true)
                        } else {
                            setShowWarning(false)
                        }
                    }

                    if (props.onChange) {
                        props.onChange(event)
                    }
                }}
                onBlur={(event) => {
                    if (props.required) {
                        setValidated(true)
                    }

                    if (props.onBlur) {
                        props.onBlur(event)
                    }
                }}
                getInputRef={(el) => {

                    inputElem.current = el
                    if (props.getInputRef) {
                        // @ts-ignore
                        props.getInputRef(el)
                    }
                }}
                // @ts-ignore
                isValid={validated && isValid}
                isInvalid={validated && !isValid}
            />
            {(showWarning && props.showFeedback) && <span style={{ color: "#cc0000" }}>
                Only numeric values allowed
            </span>}
        </>
    )


}

NumberFormatValidate.defaultProps = {
    max: null,
    min: null,
    length: null,
    required: false,
    validated: false,
    showFeedback: false,

}
export default NumberFormatValidate;
export { NumberFormatValidate }
